import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// =============================================================================
// PWA service worker registration (v0.2.29)
//
// Registers the conservative, network-first service worker (see public/sw.js).
// Registration is best-effort: if it fails, the app works exactly as before —
// the service worker only adds installability and an offline fallback page.
//
// Registered after load so it never delays first paint.
// =============================================================================
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('[pwa] service worker registration failed:', err);
    });
  });
}
